import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

import ProductList0 from "./ProductList0";
import ProductList2 from "./ProductList2";
import ProductList6 from "./ProductList6";
import ProductList11 from "./ProductList11";
import ProductList12 from "./ProductList12";

const BrandList = () => {
  const [productListNo, setProductListNo] = useState(null);
  const [data, setData] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const location = useLocation();

  const offer_id = location.state?.offer_id || "";

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setProductListNo(parseInt(parsedStyle.product_list_no));
    }
  }, []);

  const fetchOfferProducts = async (pageNum = 1) => {
    try {
      setIsFetching(true);
      const formData = new FormData();
      formData.append("customer_auto_id", sessionStorage.getItem("accessToken") || sessionStorage.getItem("admin_auto_id"));
      formData.append("admin_auto_id", sessionStorage.getItem("admin_auto_id"));
      formData.append("limit", "10");
      formData.append("page_number", pageNum.toString());
      formData.append("offer_auto_id", offer_id);
      formData.append("app_type_id", sessionStorage.getItem("app_type_id"));

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_offer_products`,
        formData
      );

      if (response.data.status === 1) {
        setTotalPages(response.data.total_pages || 1);
        setTotalItems(response.data.total_custs_count || 0);
        setData(response.data.get_admin_offer_product_lists || []);
        setPage(pageNum);
      } else {
        setTotalPages(1);
        setTotalItems(0);
        setData([]);
        setPage(pageNum);
      }
    } catch (error) {
      setTotalPages(1);
      setTotalItems(0);
      setData([]);
      setPage(pageNum);
      // console.error("Error fetching products:", error);
    } finally {
      setIsFetching(false);
    }
  };

  const handleResetFilters = () => {
    fetchOfferProducts(1); // Reset to page 1
  };

  useEffect(() => {
    setData([]);
    fetchOfferProducts();
  }, [offer_id]);

  // Mapping productListNo to Components
  const productComponents = {
    0: ProductList0,
    1: ProductList2,
    2: ProductList6,
    3: ProductList11,
    4: ProductList12,
  };

  const SelectedProductList = productComponents[productListNo] || 0;

  return (
    <div>
      {SelectedProductList && (
        <SelectedProductList
          id={offer_id}
          data={data}
          totalItems={totalItems}
          subcategoryName={''}
          fetchNextPage={() => fetchOfferProducts(page + 1)}
          hasMore={page < totalPages}
          isFetching={isFetching}
          onResetFilters={handleResetFilters}
        />
      )}
    </div>
  );
};

export default BrandList;
